<script lang="ts">
	import BaseConditionNode from '../BaseConditionNode.svelte';
	import type { NodeData } from '../../types/flow-types';
	import {
		resolveFlowNodeTypeLabel,
		resolveManualConditionSummary,
	} from '../../helpers/flowNodeCardPresentation';

	export let id: string;
	export let data: NodeData;
	export let selected: boolean = false;
	export let validated: boolean = true;
	export let errors: string[] = [];

	$: displayText = resolveManualConditionSummary(data);
	$: nodeTypeLabel = resolveFlowNodeTypeLabel('manualCondition', data);
</script>

<BaseConditionNode
	{id}
	type="manualCondition"
	hideFalseOutput={true}
	{data}
	{selected}
	{validated}
	{errors}
	cardTitle={String(displayText)}
	{nodeTypeLabel}
	{...$$restProps}
>
	<div class="body">
		<i class="fa fa-hand-pointer manual-icon" />
		<div class="description">{displayText}</div>
	</div>
</BaseConditionNode>

<style>
	.body {
		display: flex;
		align-items: center;
		gap: 0.5rem;
		padding: 0.5rem;
	}

	.manual-icon {
		color: #f59e0b;
		font-size: 1rem;
		flex-shrink: 0;
	}

	.description {
		color: var(--flow-slot-strong, #111827);
		font-size: 0.875rem;
		line-height: 1.4;
	}
</style>
